import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import UserLanguage from './UserLanguage/UserLanguage';
import Notifications from './Notifications/Notifications';
import Options from './OptionsContainer/OptionsContainer';

import classes from './UserOptionsHeader.module.css';

const UserOptionsHeader = () => {
  const userInfo = useSelector(state => state.userInfo);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (userInfo.data.systemDate) {
      setIsLoading(false);
    }
  }, [userInfo]);

  return (
    <div className={classes.userOptionsContainer}>
      {isLoading && ''}
      {!isLoading && (
        <>
          <UserLanguage />
          <Notifications />
          <Options />
        </>
      )}
    </div>
  );
};

export default UserOptionsHeader;
